module.exports = __webpack_public_path__ + "img/0.0762c776.svg";